import { Address } from "@ton/core";
import { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { SelectorItem } from "../components/Selector/types/DropdownTypes";
import { LendingsSortType } from "../entities/Lending/LendingTypes";
import { Ticker } from "../entities/Ticker/TickerTypes";
import { RaffleEndDateType } from "../features/Raffle/PlaceNFTOnRaffleFlow/store/PlaceNFTOnRaffleStore";
import { FilterTab } from "../pages/MainPage/FilterTabs/FilterDatesTabs";
import { SortTypes } from "../pages/MainPage/mainPageTypes";

export const isMobile =
  window.matchMedia("(max-width: 768px)").matches ||
  /Android|Mobi|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);

export const allowedKeys = [
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "Tab",
];

export const collectionOfferNFTsAmountKeyDownHandler = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  // Разрешённые клавиши для редактирования и навигации
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
  if (allowedKeys.includes(e.key)) return;

  // Разрешаем сочетания с Ctrl/Cmd для копирования/вставки и т.п.
  if (e.ctrlKey || e.metaKey) return;

  // Разрешаем только одиночные цифры (0-9)
  // Если нажата любая другая клавиша — блокируем ввод
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
    return;
  }

  // Получаем ссылку на текущее поле ввода и его значение
  const input = e.currentTarget;
  const { value, selectionStart, selectionEnd } = input;

  // Рассчитываем новое значение, которое получится после нажатия клавиши.
  // Учтём, что может быть выделенный фрагмент, который заменяется.
  const newValue =
    selectionStart !== null && selectionEnd !== null
      ? value.slice(0, selectionStart) + e.key + value.slice(selectionEnd)
      : value + e.key;

  // Если новое значение равно "0" (единственная цифра 0) — блокируем ввод
  // так как допустимый диапазон начинается с 1.
  if (newValue === "0") {
    e.preventDefault();
    return;
  }

  // Преобразуем новое значение в число
  const numericValue = Number(newValue);

  // Если полученное число не является целым числом или выходит за пределы [1, 100]
  if (
    !Number.isInteger(numericValue) ||
    numericValue < 1 ||
    numericValue > 100
  ) {
    e.preventDefault();
  }
};

export const percentInputKeyDownHandler: (
  e: React.KeyboardEvent<HTMLInputElement>
) => void = (e) => {
  const value = (e.target as HTMLInputElement).value;
  if (e.code === "Backspace") {
    return;
  }

  if (Number(value.charAt(0)) > 4) {
    e.preventDefault();
  }

  if (!/[0-9]/.test(e.key)) {
    e.preventDefault();
  }

  if (value.length === 2 || Number(value) > 49) {
    e.preventDefault();
  }
};

export function timeout(delay: number) {
  return new Promise((res) => setTimeout(res, delay));
}

export const bannerMockupSlide = [
  {
    id: 1,
    created: "2024-12-02T16:18:44.897Z",
    index: 0,
    isHide: false,
    background: "/OoiaPassHeader.webp",
    image: "/OoiaPassLogo.webp",
    title: "OOIA NFT Pass",
    text: "Support the OOIA marketplace, trade with zero fees, and enjoy all the benefits of the NFT Pass by becoming its owner!",
    subTitle: "Trade without fees right now",
    btnText: "Get OOIA Pass",
    btnLink: "/collection/EQB6UvgYAZeVI7F1SSJrbST-cvSGxFtM1BQYEWZ0kTEDcPiO",
  },
];

export const networkFeeValue = 0.1;
export const otherMarketplaceNetworkFeeValue = 0.3;

export const getOtherMarketplaceNetworkFee = (contractType: string) => {
  if (contractType === "gg_sale_v3_1" || contractType === "gg_sale_v2_1") {
    return 1;
  }

  return 0.3;
};

export const jettonTicketsNetworkFeeValue = 0.3;
export const tonTicketsNetworkFeeValue = 0.1;

export const MAX_TICKETS_PART = 0.6;

export const buyTicketsTonFee = 70000000;

export const skeletonsArray = Array.from(Array(12).keys());

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthsAbbreviations = [
  "Jan.",
  "Feb.",
  "Mar.",
  "Apr.",
  "May.",
  "Jun.",
  "Jul.",
  "Aug.",
  "Sep.",
  "Oct.",
  "Nov.",
  "Dec.",
];

export const sortList: SelectorItem<SortTypes>[] = [
  { label: "Newest", value: SortTypes.createdDesc },
  { label: "Oldest", value: SortTypes.createdAsc },
  { label: "Ending soon", value: SortTypes.endingSoon },
  { label: "Price low to high", value: SortTypes.priceAsc },
  { label: "Price high to low", value: SortTypes.priceDesc },
] as SelectorItem<SortTypes>[];

export const profileSortList: SelectorItem<SortTypes>[] = [
  { label: "Newest", value: SortTypes.createdDesc },
  { label: "Oldest", value: SortTypes.createdAsc },
  { label: "Ending soon", value: SortTypes.endingSoon },
  { label: "Price low to high", value: SortTypes.priceAsc },
  { label: "Price high to low", value: SortTypes.priceDesc },
];

export const collectionSortList: SelectorItem<SortTypes>[] = [
  { label: "Newest", value: SortTypes.createdDesc },
  { label: "Oldest", value: SortTypes.createdAsc },
  { label: "Price low to high", value: SortTypes.priceAsc },
  { label: "Price high to low", value: SortTypes.priceDesc },
];

export const defaultSortList: SelectorItem<SortTypes>[] = [
  { label: "Newest", value: SortTypes.createdDesc },
  { label: "Oldest", value: SortTypes.createdAsc },
  { label: "Price low to high", value: SortTypes.priceAsc },
  { label: "Price high to low", value: SortTypes.priceDesc },
];

export const lendingsSortList: SelectorItem<LendingsSortType>[] = [
  { label: "Newest", value: LendingsSortType.createdDesc },
  { label: "Oldest", value: LendingsSortType.createdAsc },
  { label: "Price low to high", value: LendingsSortType.amountAsc },
  { label: "Price high to low", value: LendingsSortType.amountDesc },
];

export const marketplaceAddress: Address = Address.parse(
  "0:06d062afd449c166de08762ec1f036ffda4925edcada70a40017ccd48559dc27"
);

export const dummyResponse: AxiosResponse = {
  data: {
    statusCode: 500,
    message: "Internal server error",
  },
  status: 500,
  statusText: "Bad Gateway",
  headers: {},
  config: {} as InternalAxiosRequestConfig,
};

export const raffleEndDates: FilterTab<RaffleEndDateType>[] = [
  { label: "1 day", value: "1d" },
  { label: "3 days", value: "3d" },
  { label: "7 days", value: "7d" },
];

export interface ITokenOption<T> {
  label: string;
  value: T;
  address: string;
}

export const tokenList: ITokenOption<Ticker>[] = [
  {
    label: "TON",
    value: Ticker.TON,
    address: "",
  },
  {
    label: "RAFF",
    value: Ticker.RAFF,
    address: "EQCJbp0kBpPwPoBG-U5C-cWfP_jnksvotGfArPF50Q9Qiv9h",
  },
  {
    label: "USD₮",
    value: Ticker.USDT,
    address: "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs",
  },
];

// TODO: replace with 0.2 after test check
export const minSalePrice = 0.2;

export const minOffsetToFetch = 50;

export const ggAuctionNetworkFee = 0.25;
